// @flow
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../../../assets/styles/colors';

export const useCommonStyles = makeStyles(theme => ({
  saveButton: {
    marginTop: theme.spacing(3),
  },
  deleteButton: {
    color: colors.danger,
  },
  modal: {
    margin: '0 auto',
    width: '90vw',
    minWidth: 300,
    maxWidth: 500,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '.875rem',
    fontWeight: 600,
  },
  message: {
    maxWidth: 300,
    textAlign: 'center',
  },
  options: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    width: '100%',
    margin: '1rem 0',
  },
  button: {
    padding: '10px 2px',
  },
}));
